<template>
  <modal
    :title="titleName"
    :show="showModal"
    @close="closeModal()"
    :largebox="true"
    :guidebox="true"
    :notClose="true"
  >
    <!-- steep 1 -->
    <div class="content" slot="content">
      <div v-if="step === 1">
        <p>É seu primeiro acesso a plataforma <b>Único Tracker</b>.</p>
        <p>
          Vou te apresentar de forma <b>bem rápida e prática</b>, para
          <b>você não perder tempo</b>. Não vai levar mais que <b>3 minutos</b>,
          e você já vai conseguir tirar seus primeiros insights!
        </p>

        <p>
          Para acessar os primeiros passos da configuração basta clicar no botão abaixo, ou no botão AJUDA (ACADEMY) na plataforma.
        </p>
        <a href="https://l.lh4.me/f3xgau" target="_blank">
          <div class="button secondary margin-top-l">
            Como configurar a plataforma
          </div>
        </a>
        
        <div v-if="false" class="video-container margin-top-l">
          <iframe
            v-if="false"
            width="960"
            height="540"
            :src="'https://www.youtube.com/embed/' + url"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          
        </div>
        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <div
              @click="saveFinishOnboarding()"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>Fechar</b>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step === 2">
        <p>Vimos que é seu primeiro acesso a plataforma <b>Único Tracker</b>.</p>
        <p>
          Vou te apresentar de forma <b>bem rápida e prática</b>, para
          <b>você não perder tempo</b>. Não vai levar mais que <b>3 minutos</b>,
          e você já vai conseguir tirar seus primeiros insights!
        </p>
        <div v-if="true" class="video-container margin-top-l">
          <iframe
            v-if="true"
            width="960"
            height="540"
            :src="'https://www.youtube.com/embed/' + url"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>

        <h3 class="margin-top-l">
          Vamos começar?
        </h3>

        <p class="">
          Primeiro, vamos precisar saber qual é sua operação. Qual o modelo de
          venda que você atua?
        </p>
        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <div @click="firstType('DROPSHIPPING')" class="button primary">
              <b>DROPSHIPPING</b>
            </div>
            <div
              @click="firstType('PLR')"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>PLR</b>
            </div>
            <div
              @click="firstType('OUTROS')"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>OUTROS</b>
            </div>
          </div>
        </div>
      </div>

      <!-- step 2 -->
      <div v-if="step === 2">
        <p>
          Pensando nisso, no menu lateral temos um módulo todo dedicado a
          <b>tutoriais</b>. Preciso falar dele, pois qualquer dúvida que você
          tenha, neste módulo, você vai encontrar um video explicativo como
          fazer.
        </p>
        <p>
          Em caso, onde você não encontre o tutorial desejado, basta enviar uma
          mensagem para nosso suporte clicando no <b>botão do whats</b>.
        </p>

        <p>
          Vamos começar os <b>2 passos simples</b> para configurar sua conta.
        </p>

        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <div @click="step = 1" class="button secondary">
              <b>VOLTAR</b>
            </div>
            <div
              @click="step++"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>COMEÇAR</b>
            </div>
          </div>
        </div>
      </div>

      <!-- step 3 -->
      <div v-if="step === 3">
        <p>
          Precisamos receber suas vendas para calcular quanto você está
          vendendo. Para isso, você precisa configurar a integração com a
          respectiva plataforma.
        </p>
        <div v-if="typeAccount === 'DROPSHIPPING'" class="margin-top-l">
          <p>
            Como você faz <b>DROPSHIPPING</b>. Abaixo está o link do video
            ensinando a fazer a integração com a SHOPIFY.
          </p>
          <a
            href="https://www.youtube.com/watch?v=tJipAy8bpzg"
            target="_blank"
            class="margin-top-l"
          >
            <div class="button primary">
              <b>CONFIGURANDO SHOPIFY</b>
            </div>
          </a>

          <p class="margin-top-l">
            Caso você não use a shopify, temos integrações com várias
            plataformas, você pode acessar todas clicando em
            <b>INTEGRAÇÕES</b> no menu lateral.
          </p>
        </div>

        <div v-else-if="typeAccount === 'PLR'" class="margin-top-l">
          <p>
            Como você faz <b>PLR</b>. Abaixo está o link do video ensinando a
            fazer a integração com a KIWIFY.
          </p>
          <a
            href="https://www.youtube.com/watch?v=JA14TmKJxbo"
            target="_blank"
            class="margin-top-l"
          >
            <div class="button primary">
              <b>CONFIGURANDO KIWIFY</b>
            </div>
          </a>

          <p class="margin-top-l">
            Caso você não use a KIWIFY, temos integrações com várias plataformas
            (hotmart e outras), você pode acessar todas clicando em
            <b>INTEGRAÇÕES</b> no menu lateral.
          </p>
        </div>

        <div v-else class="margin-top-l">
          <p class="margin-top-l">
            Temos integrações com várias plataformas de vendas, você pode
            acessar todas clicando em <b>INTEGRAÇÕES</b> no menu lateral.
          </p>
        </div>

        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <div @click="step = 1" class="button secondary">
              <b>VOLTAR</b>
            </div>
            <div
              @click="step++"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>CONTINUAR</b>
            </div>
          </div>
        </div>
      </div>
      <!-- step 4 -->
      <div v-if="step === 4">
        <p>
          Precisamos saber quanto você investe em MARKETING para calcular quanto
          você está lucrando. Para isso, você precisa configurar a integração
          com a respectiva plataforma.
        </p>
        <div class="margin-top-l">
          <p>
            Abaixo está os links dos videos ensinando a fazer a integração com
            <b>FACEBOOK ADS</b> e <b>GOOGLE ADS</b>.
          </p>
          <div
            class="flex column center text-center"
            style="align-items:center"
          >
            <a
              href="https://www.youtube.com/watch?v=JIgx4Srpvyg"
              target="_blank"
              class="margin-top-l"
            >
              <div class="button primary">CONFIGURANDO <b>FACEBOOK ADS</b></div>
            </a>

            <a
              href="https://www.youtube.com/watch?v=w3e15Q5WzeQ"
              target="_blank"
              class="margin-top-l"
              style="margin-left: 10px"
            >
              <div class="button primary">CONFIGURANDO <b>GOOGLE ADS</b></div>
            </a>
          </div>
        </div>

        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <div @click="step--" class="button secondary">
              <b>VOLTAR</b>
            </div>
            <div
              @click="saveFinishOnboarding()"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>CONTINUAR</b>
            </div>
          </div>
        </div>
      </div>

      <!-- step 5 -->
      <div v-if="step === 5">
        <p>
          Agora, você já sabe tudo que precisa para começar a usar a plataforma.
        </p>
        <p>
          Após você finalizar a integração de <b>VENDAS</b> e
          <b>MARKETING</b> em aproximadamente <b>10 minutos</b> a ferramenta já
          vai começar a mostrar seus dados na plataforma.
        </p>
        <p>
          Feito isso, basta começar a acompanhar quanto você está
          <b>lucrando!</b>
        </p>
        <p>
          Qualquer dúvida, basta enviar mensagem para nossa equipe de suporte!
        </p>

        <div class="action flex" slot="action">
          <div class="buttons flex flex-1 center margin-top-l">
            <!-- <div @click="step = 1" class="button secondary">
              <b>VOLTAR</b>
            </div> -->
            <div
              @click="closeModal()"
              class="button primary"
              style="margin-left: 10px"
            >
              <b>FECHAR</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

import { updateAccount } from "@/services/account";
import { updateUser } from "@/services/user";

export default {
  name: "modal-onboarding",
  props: {
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "accept",
    },
    url: {
      required: true,
    },
    menuName: {
      required: true,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showModal: false,
      typeAccount: null,
      step: 1,
      seenGuide: {},
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  computed: {
    titleName() {
      if (this.step === 2) {
        return "Aviso: Estamos aqui para te ajudar";
      }

      if (this.step === 3) {
        return "1° Passo - Vendas";
      }

      if (this.step === 4) {
        return "2° Passo - Marketing";
      }

      if (this.step === 5) {
        return "Parabéns!";
      }

      return "Boas Vindas";
    },
  },

  methods: {
    saveFinishOnboarding() {
      // this.step += 20;

      this.showModal = false

      let params = {
        complet_onboarding: true,
      };

      updateUser(params).then(() => {
        //this.$store.dispatch("auth", result);
      });
    },
    updateAccount() {
      let params = {
        business_type: this.typeAccount,
      };
      updateAccount(params);
    },
    firstType(typeAccount) {
      this.step += 1;
      this.typeAccount = typeAccount;

      this.updateAccount();
    },
    closeModal() {
      this.showModal = false;
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
